import { render, staticRenderFns } from "./documents-loader.vue?vue&type=template&id=6cccdca8"
import script from "./documents-loader.vue?vue&type=script&lang=js"
export * from "./documents-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports